import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

/**
 * Footer component displays comprehensive site navigation, contact information,
 * brand tagline, and legal links. Automatically updates the copyright year.
 */
const Footer = () => {
  useEffect(() => {
    const yearSpan = document.getElementById('year');
    if (yearSpan) {
      yearSpan.textContent = new Date().getFullYear().toString();
    }
  }, []);

  return (
    <footer className="footer">
      <div style={{ 
        maxWidth: '1200px', 
        margin: '0 auto', 
        padding: '2rem', 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
        gap: '2rem',
        textAlign: 'left'
      }}>
        
        {/* Quick Links */}
        <div>
          <h4 style={{ color: '#e2e8f0', marginBottom: '1rem', fontSize: '1.1rem' }}>Quick Links</h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <Link to="/" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.9rem' }}>Home</Link>
            <Link to="/services" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.9rem' }}>Services</Link>
            <Link to="/case-studies" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.9rem' }}>Case Studies</Link>
            <Link to="/blog" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.9rem' }}>Blog</Link>
            <Link to="/contact" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.9rem' }}>Contact</Link>
          </div>
        </div>

        {/* Contact Info */}
        <div>
          <h4 style={{ color: '#e2e8f0', marginBottom: '1rem', fontSize: '1.1rem' }}>Contact</h4>
          <div style={{ color: '#cbd5e1', fontSize: '0.9rem', lineHeight: '1.6' }}>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              <i className="fa-solid fa-envelope" style={{ marginRight: '0.5rem', color: 'var(--primary-color)' }}></i>
              <a href="mailto:sales@aakeeo.com" style={{ color: '#cbd5e1', textDecoration: 'none' }}>
                sales@aakeeo.com
              </a>
            </p>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              <i className="fa-solid fa-phone" style={{ marginRight: '0.5rem', color: 'var(--primary-color)' }}></i>
              <a href="tel:+918431748754" style={{ color: '#cbd5e1', textDecoration: 'none' }}>
                +91-8431748754
              </a>
            </p>
            <p style={{ margin: '0 0 0.5rem 0' }}>
              <i className="fa-brands fa-linkedin" style={{ marginRight: '0.5rem', color: 'var(--primary-color)' }}></i>
              <a
                href="https://www.linkedin.com/company/aakeeo-technologies-pvt-ltd"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#cbd5e1', textDecoration: 'none' }}
              >
                LinkedIn
              </a>
            </p>
          </div>
        </div>

        {/* Brand Tagline */}
        <div>
          <h4 style={{ color: '#e2e8f0', marginBottom: '1rem', fontSize: '1.1rem' }}>Our Mission</h4>
          <p style={{ color: '#cbd5e1', fontSize: '0.9rem', lineHeight: '1.6', fontStyle: 'italic' }}>
            "We don't just sell software solutions, we try and improve your business process."
          </p>
        </div>

      </div>

      {/* Bottom Bar */}
      <div style={{ 
        borderTop: '1px solid rgba(255,255,255,0.1)', 
        marginTop: '2rem', 
        paddingTop: '1.5rem',
        textAlign: 'center',
        color: '#94a3b8',
        fontSize: '0.8rem'
      }}>
        <p>&copy; <span id="year"></span> Aakeeo Technologies Pvt Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;